export default {"src":"/_next/static/media/bridge-skill-gap.961d073e.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};